var map = {
	"./template.bet777": 1940,
	"./template.bet777.tsx": 1940,
	"./template.betgalaxy": 1941,
	"./template.betgalaxy.tsx": 1941,
	"./template.betprofessor": 1942,
	"./template.betprofessor.tsx": 1942,
	"./template.chromabet": 1943,
	"./template.chromabet.tsx": 1943,
	"./template.default": 339,
	"./template.default.tsx": 339,
	"./template.gigabet": 2120,
	"./template.gigabet.tsx": 2120,
	"./template.pyramidbet": 2008,
	"./template.pyramidbet.tsx": 2008,
	"./template.slambet": 1944,
	"./template.slambet.tsx": 1944,
	"./template.ts": 1000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2788;